/**
 * ת.ז. לכניסה לאתר ביטוח לאומי — כפתורי מילוי מהיר בטפסי הלקוח.
 *
 * במבוגר נכנסים עם ת.ז. הלקוח, ובילד עם ת.ז. של אחד ההורים. נשמר רק המספר (לא של מי הוא),
 * והמשתמש יכול תמיד להזין ידנית ת.ז. אחרת — הכפתורים רק חוסכים הקלדה.
 */
import { validateIsraeliId } from './validationUtils';
import type { BeneficiaryType } from '../services/leadSigningService';

export interface NiLoginIdQuickFillOption {
  label: string;
  value: string;
}

interface NiLoginIdSources {
  beneficiaryType?: BeneficiaryType;
  idNumber?: string;
  fatherIdNumber?: string;
  motherIdNumber?: string;
}

export const getNiLoginIdQuickFillOptions = ({
  beneficiaryType,
  idNumber,
  fatherIdNumber,
  motherIdNumber,
}: NiLoginIdSources): NiLoginIdQuickFillOption[] => {
  const client = { label: 'ת.ז. הלקוח', value: idNumber };
  const father = { label: 'ת.ז. האב', value: fatherIdNumber };
  const mother = { label: 'ת.ז. האם', value: motherIdNumber };

  // סוג מוטב לא הוגדר (לקוחות ישנים) — מציעים את כל מה שקיים
  const candidates = beneficiaryType === 'child'
    ? [father, mother]
    : beneficiaryType === 'adult'
      ? [client]
      : [client, father, mother];

  const options: NiLoginIdQuickFillOption[] = [];
  for (const { label, value } of candidates) {
    const trimmed = value?.trim();
    // מציעים רק ת.ז. ישראלית תקינה — ערך אחר השרת ידחה
    if (!trimmed || !validateIsraeliId(trimmed)) continue;
    if (options.some(o => o.value === trimmed)) continue;
    options.push({ label, value: trimmed });
  }
  return options;
};
